export default "__VITE_ASSET__BoyrHBKP__"